// Baked replay of the dot-matrix ambience recording
// (dot-matrix_ambience_1920x1080_12s_2026-04-22): the exact per-dot brightness
// of every frame (160x90 dots, 360 frames, 12s seamless loop), delta+zigzag
// encoded in two gzipped byte planes. Payload extracted verbatim from the
// product-provided dot-matrix-drift-fixed.html embed. Pure module so the
// decode worker and the golden test share one decoder.
export const FRAME_COUNT = 360;
export const GRID_W = 160;
export const GRID_H = 90;
export const DOTS_PER_FRAME = GRID_W * GRID_H;

export function decodeFrames(raw: Uint8Array): Uint8Array {
  const total = FRAME_COUNT * DOTS_PER_FRAME;
  if (raw.length !== 2 * total) {
    throw new Error(
      `unexpected frames payload: ${raw.length} bytes, want ${2 * total}`
    );
  }
  const frames = new Uint8Array(total);
  const current = new Int32Array(DOTS_PER_FRAME);
  for (let frame = 0; frame < FRAME_COUNT; frame++) {
    const base = frame * DOTS_PER_FRAME;
    for (let k = 0; k < DOTS_PER_FRAME; k++) {
      const zigzag = raw[base + k] | (raw[total + base + k] << 8); // low | high plane
      current[k] += (zigzag >>> 1) ^ -(zigzag & 1); // unzigzag -> signed delta
      // & 255 makes the byte store truncation explicit; the accumulator can
      // exceed byte range mid-stream and the encoder relies on the wraparound
      frames[base + k] = current[k] & 255;
    }
  }
  return frames;
}
